import React, { useEffect, useState } from 'react';
import '../styles/footer.scss';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9v-2.89h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z" />
  </svg>
);

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

export const Footer = () => {
  const [links, setLinks] = useState({ supportPhone: '', facebookUrl: '', websiteUrl: '' });

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/website/content`)
      .then((res) => res.ok && res.json())
      .then((data) => {
        if (data) {
          setLinks({
            supportPhone: data.supportPhone || '',
            facebookUrl: data.facebookUrl || '',
            websiteUrl: data.websiteUrl || ''
          });
        }
      })
      .catch(() => {
        // Non-critical — the footer just won't show the contact links
      });
  }, []);

  const hasAnyLink = links.supportPhone || links.facebookUrl || links.websiteUrl;

  return (
    <footer className="site-footer">
      <div className="site-footer__brand">
        <img src="/images/logo-3.png" alt="شعار مركز التحول الرقمي والذكاء الاصطناعي" />
        <span>تنفيذ مركز التحول الرقمي و الذكاء الاصطناعي</span>
      </div>

      {hasAnyLink && (
        <div className="site-footer__links">
          {links.supportPhone && (
            <a className="site-footer__link" href={`tel:${links.supportPhone}`}>
              <PhoneIcon />
              <span dir="ltr">{links.supportPhone}</span>
            </a>
          )}
          {links.facebookUrl && (
            <a className="site-footer__link" href={links.facebookUrl} target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
              <span>فيسبوك</span>
            </a>
          )}
          {links.websiteUrl && (
            <a className="site-footer__link" href={links.websiteUrl} target="_blank" rel="noopener noreferrer">
              <GlobeIcon />
              <span>الموقع الرسمي</span>
            </a>
          )}
        </div>
      )}
    </footer>
  );
};

export default Footer;
